export default {
    me: 'me',
    customers: {
        index: 'customers'
    },
    roles: {
        index: 'admin/roles',
    },
    permissions: {
        index: 'admin/permissions',
    },
    auth: {
        login: 'login',
        logout: 'logout',
    },
    settings: {
        tokens: 'settings/tokens'
    }
}
